import Component from './Notification';

export default Component;
